import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  
  const whatsappNumber = "+917266929245";

  // Optional default message
  const message = "Hi, I want to know about spare parts.";

  return (
    <a
      href={`https://wa.me/${whatsappNumber.replace(
        /[^\d]/g,
        ""
      )}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-[999] w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg flex items-center justify-center text-white text-2xl transition-all duration-300"
      title="Chat with us on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
